__turbopack_context__.v({
  "content": "NewsCard-module-scss-module__nJvqnq__content",
  "date": "NewsCard-module-scss-module__nJvqnq__date",
  "descriptionHidden": "NewsCard-module-scss-module__nJvqnq__descriptionHidden",
  "img": "NewsCard-module-scss-module__nJvqnq__img",
  "text": "NewsCard-module-scss-module__nJvqnq__text",
  "title": "NewsCard-module-scss-module__nJvqnq__title",
});
